import {Alert, Col, Row, Spin, Switch, Typography} from 'antd'

import {useEffect, useMemo, useState} from 'react'
import {CARDS_GUTTER} from 'helpers/dashboards'
import {GET} from 'helpers/api'
import {useSelector} from 'react-redux'
import moment from 'moment'
import StatusRecordChart from './status-record-chart'
import StatusRecordDetails from './status-record-details'
import {calcInterval} from 'helpers/chart'

const {Title} = Typography

export const RailGatewayStatusAnalysis = ({gatewaysview, period}) => {
  const [statusRecords, setStatusRecords] = useState(null)
  const [statusRecord, setStatusRecord] = useState(null)
  const [visible, setVisible] = useState(false) // Start hidden by default

  const token = useSelector(state => state.auth.token)

  useEffect(() => {
    const loadData = async interval => {
      let data = []
      let response = {meta: {page: 0}}
      do {
        response = await getStatusRecordsview(interval.name, +response.meta.page + 1)
        data = data.concat(response.railgwstatusview)
      } while (moreData(response.meta))
      // Add timestamp field to each object
      data = data.map(obj => ({timestamp: obj.interval, ...obj}))
      setStatusRecords(data)
      setStatusRecord(data[data.length - 1])
    }

    if (period) {
      loadData(calcInterval(period))
    } else {
      setStatusRecords(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gatewaysview, period])

  const periodDisplayRange = useMemo(() => {
    if (period?.start && period?.end) {
      const rangeStart = period?.start.split('T')[0]
      const rangeEnd = new moment(period.end).add(-1, 'days').toISOString().split('T')[0]
      return rangeStart === rangeEnd ? rangeStart : rangeStart + ' - ' + rangeEnd
    } else {
      return ''
    }
  }, [period])

  const moreData = meta => meta.page * meta.pageSize < meta.total

  const getStatusRecordsview = (interval, page) => {
    const groupBy = `g_id,${interval}`
    const request = GET(token)
    return fetch(
      process.env.REACT_APP_BACKEND_URL +
        `/railgwstatusview?g_id=${gatewaysview.g_id}&start=${period.start}&end=${period.end}&count=${groupBy}&page=${page}&limit=1000`,
      request
    ).then(res => res.json())
  }

  return (
    <div style={{margin: 0, padding: 0, border: '1px solid var(--blue-20)'}}>
      <div>
        <Row align="middle" gutter={8} style={{padding: '0.5em 1em'}}>
          <Col>
            <Switch checked={visible} onChange={setVisible} />
          </Col>
          <Col>
            <Typography.Title level={5} style={{margin: 0}}>
              Status Chart
            </Typography.Title>
          </Col>
          {periodDisplayRange && (
            <Col style={{marginLeft: '1em'}}>
              <Typography.Text type="secondary">{periodDisplayRange}</Typography.Text>
            </Col>
          )}
        </Row>
      </div>

      {visible && (
        <>
          {gatewaysview && statusRecords && statusRecords.length > 0 ? (
            <Row gutter={CARDS_GUTTER} style={{margin: '0em'}} align="middle">
              <Col xs={24} md={5}>
                <StatusRecordDetails statusRecord={statusRecord} interval={period ? calcInterval(period) : null} />
              </Col>
              <Col xs={24} md={19}>
                <StatusRecordChart
                  gatewaysview={gatewaysview}
                  statusRecords={statusRecords}
                  setStatusRecord={setStatusRecord}
                  height={300}
                />
              </Col>
            </Row>
          ) : !statusRecords ? (
            <div style={{minHeight: '500px'}}>
              <Spin />
            </div>
          ) : (
            <Alert
              message={`There are no status records for this date range [${periodDisplayRange}]`}
              type="info"
              style={{margin: '20px auto', textAlign: 'center', backgroundColor: 'var(--blue-20'}}
            />
          )}
        </>
      )}
    </div>
  )
}

export default RailGatewayStatusAnalysis
